// Carousel API Events
export const CAROUSEL_CHANGE = 'slideChange';
export const CAROUSEL_SLIDE_IN = 'transitionEnd';
export const STOP_CAROUSEL_VIDEO_PLAYER = 'stop_carousel_video_player';

// Carousel custom class names
export const SLIDE_CLASS = '.js-slide';
export const CAROUSEL_NAV_BUTTON_CLASS = '.js-carousel-buttons';
